/**
 * @desc 修改首页横幅
 */
import { BannerEntity, BannerForm } from '@eastcoal/api/content/interface'
import { apiFetch } from '@eastcoal/common/utils/fetcher/api'
import {
  RequestOptions,
  ApiConfig
} from '@eastcoal/common/utils/fetcher/interface'

export type UpdateBannerParameter = BannerForm

const method = 'PUT'
const url = '/content/operation/banner'

export const updateBannerApi = (
  data?: UpdateBannerParameter,
  config?: Partial<RequestOptions<ApiConfig>>
) => {
  return apiFetch<BannerEntity>({
    method,
    url,
    data,
    ...config
  })
}

updateBannerApi.method = method
updateBannerApi.url = url
